export default __webpack_public_path__ + "static/media/09.7028a43d.jpg";